import {
  AnimatedContainer,
  AnimatedPage,
  AnimatedPageHeader
} from '@components/index'
import { Loader } from '@components/loader/Loader'
import { ApplicationsWidget } from '@features/applications/components/ApplicationsWidget'
import { Offers } from '@features/offers/views/user/Offers'
import { useApplication } from '@services/applications/queries/useApplication'
import { useOffers } from '@services/offers/queries/useOffers'
import { useProfile } from '@services/users/queries/useProfile'
import { Lock } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function OfferView() {
  const { t } = useTranslation('offers')
  const application = useApplication()
  const profile = useProfile(true)
  const { data, isLoading } = useOffers()

  if (isLoading) {
    return <Loader />
  }

  if (!data) {
    return <div>{t('noOffers')}</div>
  }

  return (
    <AnimatedPage className="container">
      <div className="mx-auto w-full max-w-[900px]">
        <AnimatedPageHeader title={t('title')} description={t('description')} />
        <AnimatedContainer>
          <ApplicationsWidget application={application.data} />
          {profile.data?.role !== 'ROOMMATE' && !application.data?.status ? (
            <div className="mt-4 flex flex-col items-center justify-center gap-4 rounded-3xl border border-dashed border-ink/15 px-6 py-16 text-center">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-peach/25 text-warning">
                <Lock className="h-7 w-7" />
              </span>
              <h3 className="m-0 max-w-md font-display text-lg font-bold text-ink">
                {t('application_not_activated')}
              </h3>
            </div>
          ) : (
            <Offers offers={data} />
          )}
        </AnimatedContainer>
      </div>
    </AnimatedPage>
  )
}
